export default {
    titulo: "Obras",
    nueva: "Nueva obra",
    editar: "Editar obra",
    codigo: "Código",
    descripcion: "Descripción",
    fecha: "Fecha de alta",
    sucursal: "Sucursal",
    estado: "Estado",
    activa: "Activa",
    finalizada: "Finalizada",
    fechaFin: "Fecha de finalización",
    buscar: "Buscar por descripción",
    fechaIni: "Desde",
    fechaHasta: "Hasta",
    todas: "Todas",
    finalizar: "Finalizar",
    finalizarTitulo: "Finalizar obra",
    pregFinalizar: "¿Desea finalizar esta obra? Podrá reactivarla luego.",
    reactivar: "Reactivar",
    eliminar: "Eliminar",
    eliminarTitulo: "Eliminar obra",
    pregEliminar: "¿Desea eliminar esta obra? Esta acción no se puede deshacer.",
    guardar: "Guardar",
    obraCreada: "Obra creada con éxito",
    obraActualizada: "Obra actualizada con éxito",
};
